/* [RR feat] Kaufbox auf der Produktseite: Größenkacheln und nächstmöglicher Liefertag.

   Die Variantenlogik des Themes bleibt unberührt: Die Kacheln setzen nur den
   Wert im versteckten <variant-selects> und lösen dort ein change-Event aus.
   Ab da übernimmt product-info wie bisher (Preis, Formular-ID, Verfügbarkeit,
   alle Elemente mit data-bd-price-note-sync). */
(function () {
  'use strict';

  /* --- Größe als Kacheln -------------------------------------------------- */
  class RrSizeTiles extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.pick.bind(this));
    }

    pick(event) {
      var tile = event.target.closest('.rr-buy__size');
      if (!tile || tile.disabled) return;

      var select = document.querySelector('#variant-selects-' + this.dataset.section + ' select');
      if (!select) return;

      /* Sofort umschalten: Kachel, Preis, Knopftext und Varianten-ID im Formular.
         product-info holt danach die Section vom Server (Verfügbarkeit, Bilder,
         Adresse), das dauert je nach Verbindung eine Sekunde; der Kunde sieht den
         neuen Preis aber schon jetzt. Der Serverstand überschreibt mit denselben
         Werten. */
      var all = this.querySelectorAll('.rr-buy__size');
      for (var i = 0; i < all.length; i++) {
        var active = all[i] === tile;
        all[i].classList.toggle('is-active', active);
        all[i].setAttribute('aria-pressed', active ? 'true' : 'false');
      }
      this.showPrice(tile.dataset.price, tile.dataset.variantId);

      select.value = tile.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    showPrice(price, variantId) {
      var scope = this.closest('product-info') || document;
      if (price) {
        var amounts = scope.querySelectorAll('.rr-buy__price-amount');
        for (var a = 0; a < amounts.length; a++) {
          /* Bei Streichpreis bleibt die Zeile dem Server überlassen. */
          if (!amounts[a].querySelector('.rr-buy__price-old')) amounts[a].textContent = price;
        }
        var btn = scope.querySelectorAll('.rr-buy__btn-price');
        for (var b = 0; b < btn.length; b++) btn[b].textContent = price;
      }
      if (variantId) {
        var inputs = scope.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]');
        for (var c = 0; c < inputs.length; c++) inputs[c].value = variantId;
      }
    }
  }
  if (!customElements.get('rr-size-tiles')) customElements.define('rr-size-tiles', RrSizeTiles);

  /* --- Nächstmöglicher Liefertag aus Logifresh ---------------------------- */
  /* Ohne Postleitzahl: der Endpunkt liefert die Tage der allgemeinen
     Versandregel (derzeit für alle Postleitzahlen gleich). Die genaue Wahl
     trifft der Picker im Warenkorb. Antwortet Logifresh nicht, bleibt die
     Zeile weg: lieber keine Zeile als ein Termin, der nicht stimmt. */
  var DAYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var CACHE_MS = 30 * 60 * 1000;
  var TIMEOUT_MS = 8000;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fromKey(k) { var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(k || '')); return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null; }
  function fmtShort(k) { var d = fromKey(k); return d ? DAYS[d.getDay()] + ', ' + pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' : ''; }
  function isFuture(k) { var d = fromKey(k); if (!d) return false; var t = new Date(); t.setHours(0, 0, 0, 0); return d >= t; }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function write(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function setupDelivery() {
    var rows = document.querySelectorAll('[data-rr-next-delivery]');
    for (var i = 0; i < rows.length; i++) setupRow(rows[i]);
  }

  function setupRow(row) {
    if (row.dataset.rrDone === 'true') return;
    row.dataset.rrDone = 'true';
    var template = row.getAttribute('data-template') || '';
    if (template.indexOf('{datum}') < 0) return;

    var show = function (k) {
      var text = fmtShort(k);
      if (!text) return;
      row.textContent = template.replace('{datum}', text);
      row.hidden = false;
    };

    var base = String(row.getAttribute('data-api-base') || '').replace(/\/+$/, '').replace(/\/get-available-delivery-dates$/, '');
    var shop = row.getAttribute('data-shop-domain') || '';
    if (!base || !shop) return;

    var cacheKey = 'rr_naechster_termin_' + shop;
    var raw = read(cacheKey);
    if (raw) {
      try {
        var c = JSON.parse(raw);
        if (c && c.datum && isFuture(c.datum)) {
          show(c.datum);
          if (typeof c.ts === 'number' && Date.now() - c.ts < CACHE_MS) return;
        }
      } catch (e) {}
    }

    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, TIMEOUT_MS) : null;
    var url = base + '/get-available-delivery-dates?shop_domain=' + encodeURIComponent(shop) + '&num_days=40';
    fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (json) {
        if (timer) clearTimeout(timer);
        var list = (json && json.dates) || [];
        var first = list.length ? String(list[0].delivery_date || '').slice(0, 10) : '';
        if (!first || !isFuture(first)) return;
        write(cacheKey, JSON.stringify({ ts: Date.now(), datum: first }));
        show(first);
      })
      .catch(function () { if (timer) clearTimeout(timer); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupDelivery);
  else setupDelivery();
  /* Nach einem Variantenwechsel tauscht das Theme Teile der Section aus. */
  document.addEventListener('shopify:section:load', setupDelivery);
  document.addEventListener('variant:change', setupDelivery);
})();
